<template>
  <div>
    <!-- Modal Mode -->
    <v-dialog
      v-if="!tabMode"
      v-model="dialogModel"
      content-class="my-custom-dialog"
      persistent
      max-width="60%"
      style="overflow-y: auto; border-radius: 20px !important"
      :scrollable="true"
    >
      <v-overlay
        v-if="loading"
        z-index="1000"
        :absolute="absolute"
        :opacity="opacity"
        style="height: 100%; width: 100%; opacity: 1 !important"
      >
        <v-progress-circular
          :size="100"
          :width="10"
          style="color: #04aa6d; z-index: 1000"
          indeterminate
          >Pričekajte</v-progress-circular
        >
      </v-overlay>
      <v-card v-if="dialogModel">
        <v-card-title
          style="background-color: #1577da; font-weight: bold; color: white"
        >
          <span class="text-h5" style="font-weight: bold">{{ title }}</span>
        </v-card-title>
        <v-card-text class="pb-1">
          <slot></slot>
        </v-card-text>
        <v-card-actions class="pr-10 pl-10">
          <slot name="actions"></slot>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Tab Mode -->
    <v-card v-if="tabMode && dialogModel" class="tab-mode-card">
      <v-overlay v-if="loading" :absolute="true" :opacity="0.8">
        <v-progress-circular
          :size="100"
          :width="10"
          style="color: #04aa6d; z-index: 1000"
          indeterminate
          >Pričekajte</v-progress-circular
        >
      </v-overlay>
      <v-card-text class="pb-1 pt-3">
        <slot></slot>
      </v-card-text>
      <v-card-actions class="pr-10 pl-10">
        <slot name="actions"></slot>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'DialogWrapper',
  props: {
    tabMode: {
      type: Boolean,
      default: false
    },
    dialog: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Novi račun'
    },
    absolute: {
      type: Boolean,
      default: true
    },
    opacity: {
      type: Number,
      default: 1
    }
  },
  computed: {
    dialogModel: {
      get () {
        return this.dialog
      },
      set (val) {
        this.$emit('update:dialog', val)
      }
    }
  }
}
</script>

<style scoped>
.v-dialog__content >>> .my-custom-dialog {
  position: absolute;
  top: 30px;
  border-radius: 25px !important;
}

/* Tab Mode styles */
.tab-mode-card {
  width: 100% !important;
  height: 100% !important;
  box-shadow: none !important;
  margin: 0 !important;
  border-radius: 0 !important;
  display: flex !important;
  flex-direction: column !important;
  overflow: hidden !important;
}

.tab-mode-card .v-card__text {
  flex: 1 !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

.my-overlay >>> .v-overlay__content {
  width: 100%;
  height: 100%;
}
</style>
